<template>
    <div class="desing">
        <titles name="安装信息"></titles>
        <ul class="content">
            <li>
                <div class="titleDiv">
                    安装时间： 
                    <span class="titleSpan">{{item.installTime}}</span> 
                </div>
                <div class="titleDiv">
                    安装地址：
                    <span class="titleSpan">{{item.installAddress}}</span> 
                </div>
                <div class="titleDiv">
                    安装备注： 
                    <span class="titleSpan">{{item.installRemarks}}</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import titles from '@/components/titiles.vue';
import lion from '@/assets/img/lion.jpg'
export default {
    components:{
        titles,
    },
    props: {
        item: {
        type: Object,
        default: {}
        },
    },
    data(){
        return {
            lion
        }
    }
}
</script>
<style lang="scss" scoped>
.desing{
    background: $ffff;
    margin-bottom: 20px;
    .content{
        margin:20px 55px 0 55px;
        background: $ffff;
        font-size:24px;
        color:$color-51;
        padding-bottom:10px;
        li{
            div{
                margin-bottom: 27px;
            }
            img{
                width:110px;
                height:110px;
            }
        }
        span{
            color: $color-153;
        }
    }
}
.titleDiv{
    position: relative;
    .titleSpan{
        position: absolute;
        left: 150px;
    }
}
</style>


